<template>
  <v-container fluid>
    <!-- Page Header -->
    <v-row class="mt-n4" align="center" justify="center">
      <v-col cols="12" md="auto">
        <div class="d-flex align-center justify-center">
          <v-avatar color="primary" size="52" class="mr-3 elevation-2">
            <v-icon color="white" size="28">receipt_long</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-bold grey--text text--darken-2">Aprobación de Órdenes</div>
            <div class="text-caption grey--text">Gestión y seguimiento de órdenes de compra</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filters -->
    <v-row justify="center" class="mb-2">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          v-model="business_selected"
          :items="itemsBussines"
          item-text="text"
          item-value="value"
          label="Unidad de negocio"
          outlined dense hide-details
          color="primary"
          prepend-inner-icon="mdi-office-building-outline"
          @change="onBusinessChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          v-model="location_selected"
          :items="filteredLocations"
          item-text="text"
          item-value="value"
          label="Sucursal"
          outlined dense hide-details
          color="primary"
          prepend-inner-icon="mdi-map-marker-outline"
          @change="onLocationChange"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <!-- KPI Cards -->
    <v-row class="mb-4" v-if="orders.length > 0">
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center mb-2">
            <v-icon color="primary" class="mr-2" small>mdi-clipboard-list-outline</v-icon>
            <span class="text-caption font-weight-bold grey--text text-uppercase">Total Órdenes</span>
          </div>
          <div class="text-h4 font-weight-black primary--text">{{ orders.length }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" v-for="(amount, code) in kpiAmounts" :key="'amt-'+code">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center mb-2">
            <v-icon color="success" class="mr-2" small>mdi-cash-multiple</v-icon>
            <span class="text-caption font-weight-bold grey--text text-uppercase">Monto {{ code }}</span>
          </div>
          <div class="text-h5 font-weight-black success--text">{{ currencyFormat(amount) }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" v-for="(count, status) in kpiByStatus" :key="'st-'+status">
        <v-card outlined class="rounded-xl pa-4">
          <div class="d-flex align-center mb-2">
            <v-icon :color="statusKpiColor(status)" class="mr-2" small>mdi-tag-outline</v-icon>
            <span class="text-caption font-weight-bold grey--text text-uppercase">{{ status }}</span>
          </div>
          <div class="text-h4 font-weight-black" :class="statusKpiColor(status)+'--text'">{{ count }}</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="rounded-xl mt-1" outlined>
      <v-data-table :search="search" :headers="headers" :items="orders" :loading="loading" class="elevation-0">
        <template v-slot:top>
          <v-toolbar flat class="rounded-t-xl px-2">
            <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
            <v-toolbar-title class="font-weight-bold">Órdenes</v-toolbar-title>
            <v-chip small color="primary" class="ml-2 font-weight-bold">{{ orders.length }}</v-chip>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Buscar..."
              outlined dense hide-details clearable
              prepend-inner-icon="mdi-magnify"
              style="max-width: 280px"
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:[`item.order_id`]="{ item }">
          <span class="primary--text font-weight-bold order-link" @click="showOrder(item.order_id, true, 1)">
            {{ filLeft(item.order_id.toString(), 12, "0") }}
          </span>
        </template>

        <template v-slot:[`item.entity_name`]="{ item }">
          <span class="primary--text font-weight-medium order-link" @click="viewEntity(item.entity_id)">
            {{ item.entity_name }}
          </span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip small :color="time_line_orders(item.last_status_id).color" dark class="font-weight-bold">
            {{ item.last_status_name }}
          </v-chip>
        </template>

        <template v-slot:no-data>
          <div class="text-center py-12">
            <v-icon size="72" color="grey lighten-1">receipt_long</v-icon>
            <div class="text-h6 grey--text mt-3">Sin órdenes para mostrar</div>
            <div class="text-body-2 grey--text mt-1">Selecciona los filtros y consulta las órdenes disponibles</div>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Order from "@/components/Shop/Order.vue";
export default {
  components: { Order },
  data: () => ({
    search: "",
    dialog: false,
    dialogDelete: false,
    suplidor: false,
    cliente: false,
    disabledName: false,
    plazoPagoSuplidor: null,
    plazoPagoCliente: null,
    documents: [],
    rncValid: false,
    accounts: [],
    orders: [],
    itemsBussines: [],
    business_selected: 0,
    location_selected: 0,
    cxc: "",
    cxp: "",
    status_user: "",
    lastFilters: "",
    last_consult: "",
    selectedDocument: "",
    selectedtypesNcfCliente: "",
    selectedtypesNcfSuplidor: "",
    selectedProvincies: "",
    loading: false,
    headers: [
      { text: "Orden",            align: "start", value: "order_id" },
      { text: "Unidad de Negocio",               value: "business_unit_description_long" },
      { text: "Sucursal",                         value: "location_description_long" },
      { text: "Suplidor",                         value: "entity_name" },
      { text: "Comprador",                        value: "use_fullname" },
      { text: "Monto",            align: "end",  value: "amount" },
      { text: "Status",                           value: "status" },
    ],

    editedIndex: -1,
    editedItem: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva orden" : "Editar orden";
    },
    kpiAmounts() {
      const totals = {};
      for (const order of this.orders) {
        const code = order.currency_code || 'DOP';
        if (!totals[code]) totals[code] = 0;
        const details = Array.isArray(order.order_details) ? order.order_details : [];
        for (const d of details) {
          const sub = (d.quantity || 0) * (d.price || 0);
          totals[code] += sub - sub * (d.discount || 0);
        }
      }
      return totals;
    },
    kpiByStatus() {
      const counts = {};
      for (const order of this.orders) {
        const name = order.last_status_name || 'Desconocido';
        counts[name] = (counts[name] || 0) + 1;
      }
      return counts;
    },
    filteredLocations() {
      // Sin unidad seleccionada solo se permite "Todas"
      if (!this.business_selected || this.business_selected == 0) {
        return [{ text: "Todas", value: 0 }];
      }
      const all = this.$store.state.auth.locations || [];
      const locs = all.filter((l) => l.bus_id === this.business_selected);
      return [{ text: "Todas", value: 0 }, ...locs];
    },
  },

  watch: {},
  mounted() {
    this.initialize();
  },
  created() { },

  methods: {
    statusKpiColor(statusName) {
      const n = (statusName || '').toLowerCase();
      if (n.includes('aprobad')) return 'success';
      if (n.includes('pend'))    return 'warning';
      if (n.includes('rechaz') || n.includes('cancel')) return 'error';
      return 'primary';
    },
    changeBusiness(data) {
      this.getData(data);
    },
    // El servidor decide qué órdenes ve el usuario (contador SHOP-142, niveles de aprobación
    // y sucursales con acceso) a partir del token; aquí solo se envía unidad y sucursal.
    async getData(data) {
      this.loading = true;
      try {
        const resultOrders = await this.api_Post("shopping/orders_to_approve", {
          business: data.business || 0,
          location: data.location || 0,
        });
        const result = await resultOrders.json();
        if (resultOrders.status !== 200) {
          this.$toast.warning(result.message || "No se pudieron cargar las órdenes");
          this.orders = [];
          return;
        }

        this.orders = result.data;
        for (let key in this.orders) {
          // Validar que order_details exista y sea un array
          if (!this.orders[key].order_details || !Array.isArray(this.orders[key].order_details)) {
            this.orders[key].amount = `${this.orders[key].currency_code || 'USD'} ${this.currencyFormat(0)}`;
            continue;
          }

          let amount = this.orders[key].order_details.reduce((acc, item) => {
            const subtotal = item.quantity * item.price;
            const discountAmount = subtotal * (item.discount || 0);
            return acc + (subtotal - discountAmount);
          }, 0);
          this.orders[key].amount = `${this.orders[key].currency_code || 'USD'} ${this.currencyFormat(amount)}`;
        }
      } catch (error) {
        this.$toast.error(error.message);
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },

    async initialize() {
      this.itemsBussines = [
        { text: "Todas", value: 0 },
        ...(this.$store.state.auth.bussines_units || []),
      ];
      this.business_selected = 0;
      this.location_selected = 0;
      this.consult();
    },

    onBusinessChange() {
      this.location_selected = 0;
      this.consult();
    },

    onLocationChange() {
      this.consult();
    },

    consult() {
      // "Todas" (0): el servidor limita a las sucursales con acceso de la unidad seleccionada
      this.changeBusiness({
        business: this.business_selected,
        location: this.location_selected || 0,
      });
    },

    editItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(item) {
      const responseRequest = await this.api_Post("shopping/order_register", item);

      if (responseRequest.status == 200) {
        this.getData();

        let data = await responseRequest.json();

        // this.$router.push({
        //     name: "ViewInvoice",
        //     params: { id: data[0].invoice_number },
        // });

        // this.$toast.success("agregado con exito!");
        this.dialog = false;
      } else {
        this.$toast.error("error al registrar la factura!");
      }
    },
  },
};
</script>

<style scoped>
.order-link {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  transition: opacity 0.15s;
}
.order-link:hover {
  opacity: 0.7;
}
</style>
